<template lang="html">
    <v-container fluid class="pa-0 pl-3">
        <v-row>
            <v-col class="py-0">
                <v-text-field
                        v-model="searchField"
                        placeholder="Search..."
                        solo
                        single-line
                        clearable
                        autofocus
                        hint="Example : transaction.businessUnit.unitID.value=7-0-0"
                        persistent-hint
                        prepend-icon="mdi-magnify"
                        @keyup.enter="launchSearch"
                >
                    <template v-slot:append-outer>
                        <v-btn v-on:click="launchSearch" dark color="blue" style="top: -6px" :disabled="loading">
                            Search
                        </v-btn>
                    </template>
                </v-text-field>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import {SEARCH_NS} from "@/store/modules/search/constants";
    import {mapActions, mapGetters} from 'vuex';

    export default {
        data() {
            return {
                searchField: ""
            }
        },
        computed: {
            ...mapGetters(SEARCH_NS, [
                'searchQueryStr',
                'loading'
            ])
        },
        watch: {
            searchQueryStr(val) {
                this.searchField = val;
            }
        },
        methods: {
            ...mapActions(SEARCH_NS, [
                'gotToPage'
            ]),
            launchSearch() {
                if(!this.loading){
                  this.updateSearchQueryStr(this.searchField || "");
                  this.gotToPage(1);
                }

            },
            ...mapActions(SEARCH_NS, [
                'updateSearchQueryStr'
            ])
        },
        created() {
            this.searchField = this.searchQueryStr;
        }
    }
</script>